import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/admin`;

export const fetchAllAgents = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/agents`, getAuthHeaders());
  return res.data;
};

export const getAllIntegrationSettings = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/integration-settings`,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchAllMeetings = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/meetings`, getAuthHeaders());
  return res.data;
};

export const fetchAllParticipants = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/participants`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getAllSettings = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/settings`, getAuthHeaders());
  return res.data;
};

export const fetchAllTransactions = async () => {
  const res = await axiosInstance.get(
    `${BASE_URL}/transactions`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getAllUserActivityAPI = () =>
  axiosInstance.get(`${BASE_URL}/activity`, getAuthHeaders());

export const getUsers = () =>
  axiosInstance.get(`${BASE_URL}/users`, getAuthHeaders());

export const addCredits = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/add-credits`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchMeetingByUuid = async (meetingId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/meeting/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getTaskByIdApi = async (meetingId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/task/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteMeetingApi = async (meetingId) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/meeting/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteAgent = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/agent/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteIntegrationSettingByUuid = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/integration-setting/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteParticipant = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/participant/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteSettingByUuid = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/setting/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteUserApi = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/user/${uuid}`,
    getAuthHeaders(),
  );

  return res.data;
};
